// src/pages/TippingCancelledPage.js

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProfile } from '../context/ProfileContext';
import { useMusic } from '../context/MusicContext';

const TippingCancelledPage = () => {
  const navigate = useNavigate();
  const { activeProfile } = useProfile();
  const { setIsExpanded } = useMusic(); // To ensure the player is visible

  useEffect(() => {
    // When this page loads, we want to ensure the main music player is expanded
    // so the user returns to their music context immediately.
    setIsExpanded(true);

    // Set a timer to automatically redirect after a delay
    const redirectTimer = setTimeout(() => {
      if (activeProfile?.id) {
        // If we know the active profile, go to their profile page
        navigate(`/profile/${activeProfile.id}`);
      } else {
        // As a fallback, go to the homepage
        navigate('/home');
      }
    }, 3000); // 3000 milliseconds = 3 seconds

    // This is a cleanup function. If the user navigates away manually
    // before the 3 seconds are up, it will clear the timer.
    return () => clearTimeout(redirectTimer);

  }, [navigate, activeProfile, setIsExpanded]); // Dependencies for the effect

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center bg-gray-50 p-6">
      <div className="max-w-md">
        {/* An icon to provide visual feedback */}
        <svg xmlns="http://www.w3.org/2000/svg" className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>

        <h1 className="mt-4 text-2xl font-bold text-gray-800">
          Tipping Cancelled
        </h1>
        <p className="mt-2 text-md text-gray-600">
          You have not been charged.
        </p>
        <p className="mt-6 text-sm text-gray-500">
          Returning to your music...
        </p>
        
        {/* A subtle spinner to indicate something is happening */}
        <div className="mt-4 mx-auto w-6 h-6 border-2 border-dashed border-gray-300 rounded-full animate-spin"></div>
      </div>
    </div>
  );
};

export default TippingCancelledPage;